module.exports = __webpack_public_path__ + "static/19-11c5223cf03126cb405bb400d4531885.jpg";